import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SystemTagsService } from '../system-tags.service';
import { SystemTags } from '../typings/system-tags.typing';

@Component({
    selector: 'gc-system-tag',
    templateUrl: './system-tag.component.html',
    styleUrls: ['./system-tag.component.scss'],
    standalone: false
})
export class SystemTagComponent {
  @Input() readonly: boolean;
  @Input() tag: SystemTags.TagDefinitionForUi;
  @Input() showLeadingIcon = false;
  @Input() tagMarkedForRemoval = false;
  @Input() allowColorChange = false;
  @Output() onTagMark = new EventEmitter<'Disable'|'Enable'|'delete'>();
  @Output() onTagColorChange = new EventEmitter<SystemTags.TagColor>();

  tagColorClassMap: Record<SystemTags.TagColor, string> = this.systemTagsService.tagColorClassMap;

  constructor (
    private systemTagsService: SystemTagsService
  ) { }
}
